<template>
    <div class="row">
        <div class="col-md-12 mb-50">
            <label class="form-label">Çalışma Günü</label>
            <input :class="{'is-invalid':value.countOfDaysWorked < value.defaultCountOfDaysWorked}" v-model="value.countOfDaysWorked" placeholder="Çalışma Günü" class="form-control" />
        </div>
        <div class="col-12 mb-1">
            <div class="alert alert-primary mb-0">
                <div class="alert-body px-50 py-25">
                    Çalışma günü en az {{value.defaultCountOfDaysWorked}} gün olmalıdır.
                </div>
            </div>
        </div>
        <div class="col-md-12">
            <label class="form-label">Sefer Sayısı</label>
            <input v-model="value.countOfTrips" placeholder="Sefer Sayısı" class="form-control" />
        </div>
    </div>
</template>

<script>
export default {
    props:{
        value:Object,
    },
}
</script>

<style>

</style>